import React from 'react';
import GirviPageShell from '../components/common/GirviPageShell';
import VatavAccountsPanel from '../components/common/vatav/VatavAccountsPanel';

export default function VatavLedgerPage() {
  return (
    <GirviPageShell title="Vatav Ledger" subtitle="VPS B" chipLabel="VATAV" compact>
      <VatavAccountsPanel />
    </GirviPageShell>
  );
}
